<template>
    <div v-if="$parent.mediaProperty.configuration" class="configuration">
        <div style="display:flex; flex-direction: row; margin-bottom: 2em;">
            <div>
                <div class="formRow" style="background-color: #a9a9a9;">
                    <h4>Image Location</h4>
                    <h4>Image Path</h4>
                    <div></div>
                </div>
                <div class="formRow">
                    <h4>Top</h4>
                    <input type="text" v-model="$parent.mediaProperty.configuration.images.top" @change="save('images')" :disabled="!$parent.mediaProperty.isActive"/>
                    <UploadMediaPropertyModal openButtonText="Upload"
                                                    modalTitle="Upload Image"
                                                    :fileKey="$parent.mediaProperty.configuration.images.top"
                                                    acceptFileTypes="image/*"
                                                    :onFileUpload="() => getImageLink('top')"
                                                    permission= "public-read"></UploadMediaPropertyModal>
                </div>
                <div class="formRow">
                    <h4>Middle</h4>
                    <input type="text" v-model="$parent.mediaProperty.configuration.images.middle" @change="save('images')" :disabled="!$parent.mediaProperty.isActive"/>
                    <UploadMediaPropertyModal openButtonText="Upload"
                                                modalTitle="Upload Image"
                                                :fileKey="$parent.mediaProperty.configuration.images.middle"
                                                acceptFileTypes="image/*"
                                                :onFileUpload="() => getImageLink('middle')"
                                                permission= "public-read"></UploadMediaPropertyModal>
                </div>
                <div class="formRow">
                    <h4>Bottom</h4>
                    <input type="text" v-model="$parent.mediaProperty.configuration.images.bottom" @change="save('images')" :disabled="!$parent.mediaProperty.isActive"/>
                    <UploadMediaPropertyModal openButtonText="Upload"
                                                modalTitle="Upload Image"
                                                :fileKey="$parent.mediaProperty.configuration.images.bottom"
                                                acceptFileTypes="image/*"
                                                :onFileUpload="() => getImageLink('bottom')"
                                                permission= "public-read"></UploadMediaPropertyModal>
                </div>
            </div>
            <div style="width:200px; padding-left: 30px; box-sizing: border-box; display: flex; flex-direction: column; justify-content: center;">
                <img :src="topImageLink" style="width: 100%"/>
                <img :src="middleImageLink" style="width: 100%;"/>
                <img :src="bottomImageLink" style="width: 100%"/>
                <div>Not to scale</div>
            </div>
        </div>
        <div class="formRow">
            <h4>Header Text: </h4>
            <input type="text" v-model="HeaderText" @change="save('headerTextJson')" :disabled="!allowEdit" />
            <TranslatedText 
                v-if="HeaderText.length > 0 && $parent.mediaProperty.configuration.headerTextJson.length > 1"
                :textJson="$parent.mediaProperty.configuration.headerTextJson"
                position="bottom" alignment="start" 
                :defaultLanguage="$parent.mediaProperty.defaultLanguage"></TranslatedText>
        </div>
        <div class="formRow">
            <h4>Footer Text: </h4>
            <input  type="text" v-model="FooterText" @change="save('footerTextJson')" :disabled="!allowEdit" />
            <TranslatedText 
                v-if="FooterText.length > 0 && $parent.mediaProperty.configuration.headerTextJson.length > 1"
                :textJson="$parent.mediaProperty.configuration.footerTextJson"
                position="bottom" alignment="start" 
                :defaultLanguage="$parent.mediaProperty.defaultLanguage"></TranslatedText>
        </div>
        <div class="formRow">
            <h4>Items:</h4>
            <button class="addRowButton" @click="addItem" :disabled="!$parent.mediaProperty.isActive"><i class="fa-circle-plus fas fa-2xl"></i>Add Item</button>
        </div>
        <div class="datagrid" v-if="ready">       
                <div class="gridRow">
                    <div class="dataCell header tiny"></div>
                    <div class="dataCell header large">Text</div>
                    <div class="dataCell header small">Checked</div>
                    <div class="dataCell header small">&nbsp;</div>
                </div>
                <VueDraggableNext class="dragArea list-group w-full" :list="items" @update="moveElement" >        
                    <div v-for="(item, index) in items" :key="index" class="gridRow draggable">
                        <div class="dataCell tiny" :class="getGridClass(index)">
                            <i class="fa-solid fa-grip-vertical"></i>
                        </div>
                        <div class="dataCell large" :class="getGridClass(index)">
                            <input type="text" v-model="item.itemText" @change="save('textJson', index)" :disabled="!allowEdit" />
                            <TranslatedText 
                                v-if="item.textJson && item.textJson.length > 1"
                                :textJson="item.textJson" position="bottom" alignment="start" 
                                :defaultLanguage="$parent.mediaProperty.defaultLanguage"></TranslatedText>     
                       </div>
                        <div class="dataCell small" :class="getGridClass(index)" >
                            <input type="checkbox" :disabled="!allowEdit" v-model="item.checked">
                        </div>
                        <div class="dataCell small" :class="getGridClass(index)">
                            <button class="deleteButton" @click="deletePieSlice(index)" :disabled="!$parent.mediaProperty.isActive"><i class="fas fa-trash-can"></i></button>
                        </div>
                    </div>
                </VueDraggableNext>
        </div>
    </div>
    
</template>

<script>

import {data} from '../../shared/data';
import {translation} from '../../shared/translation';
import {storage} from '../../shared/storage';
import TranslatedText from '@/components/shared/TranslatedText.vue';
import UploadMediaPropertyModal from './UploadMediaPropertyModal.vue';
import { VueDraggableNext} from 'vue-draggable-next';

export default {
    name: 'ChecklistEdit',
    components: { TranslatedText, UploadMediaPropertyModal, VueDraggableNext },
    data: function() {
        return {
            positions: [],
            alignments: [],
            topImageLink: null,
            bottomImageLink: null,
            middleImageLink: null,
            ready: false
        }
    },
    props: {
        allowEdit: Boolean
    },
    computed: {
        HeaderText: {
            get() {
                return translation.getTextForLanguage(this.$parent?.mediaProperty?.configuration?.headerTextJson, this.$parent.mediaProperty.defaultLanguage);
            },
            set(newText) {
                translation.setTextForLanguage(this.$parent.mediaProperty.configuration, this.$parent.mediaProperty.defaultLanguage, 'headerTextJson', newText);
            }
        },
        FooterText: {
            get() {
                return translation.getTextForLanguage(this.$parent?.mediaProperty?.configuration?.footerTextJson, this.$parent.mediaProperty.defaultLanguage);

            },
            set(newText) {
                translation.setTextForLanguage(this.$parent.mediaProperty.configuration, this.$parent.mediaProperty.defaultLanguage, 'footerTextJson', newText);
            }
        },
        items() {
            return this.$parent.mediaProperty.configuration.items;
        }
    },
    async mounted() {
        if(!this.$parent.mediaProperty.configuration) {
            this.$parent.mediaProperty.configuration = {
                images: {
                    top: '',
                    bottom: '',
                    middle: ''
                },
                width: 0,
                selectable: false,
                items: []
            }
        }

        this.positions = await data.getEnumList("ToolTipPositions");
        this.alignments = await data.getEnumList("ToolTipAlignments");

        if(this.$parent.mediaProperty.configuration.items)
            this.$parent.mediaProperty.configuration.items.sort((a, b) => a.id - b.id);

        this.addGettersAndSetters(this.$parent.mediaProperty.configuration.items);    

    },
    watch: {
        '$parent.mediaProperty.configuration.images': {
            handler: async function (newImages) {
                if (newImages?.top) {
                    this.getImageLink('top');
                } else {
                    this.topImageLink = null;
                }

                if (newImages?.middle) {
                    this.getImageLink('middle');
                } else {
                    this.middleImageLink = null;
                }

                if (newImages?.bottom) {
                    this.getImageLink('bottom');
                } else {
                    this.bottomImageLink = null;
                }
            },
            deep: true, // Watch for changes in the entire images object
            immediate: true,
        },
    },
    methods: {
        moveElement: function() {

            this.$parent.mediaProperty.configuration.items.forEach((item, index) => {
                item.id = index + 1; // Adjust order starting from 1 (or 0 if preferred)
            });

            this.save();       
        },    
        getGridClass: function(index) {
            if(index === this.items.length - 1)
                return "last"
            else 
                return "";
        },
        addGettersAndSetters: function(items) {
            //if(!items) return;
            const vm = this; // Capture the Vue instance context
            items.forEach(item => {
                if (!Object.getOwnPropertyDescriptor(item, "itemText")) {
                Object.defineProperty(item, "itemText", {
                    get() {
                        return translation.getTextForLanguage(item.textJson, vm.$parent.mediaProperty.defaultLanguage);
                    },
                    set(newText) {
                        translation.setTextForLanguage(item, vm.$parent.mediaProperty.defaultLanguage, 'textJson', newText);
                    }
                });
                }
            });

            this.ready = true; 
        },
        getImageLink: async function(position) {
            var imageLink =  null; 
            if(this.$parent.mediaProperty.configuration.images?.[position] != null) {
                imageLink = await storage.getWasabiLink(this.$parent.mediaProperty.configuration.images[position], true) + '?t=' + Date.now();
            }

            if(position === 'top')
                this.topImageLink = imageLink;
            else if(position === 'bottom')
                this.bottomImageLink = imageLink;
            else if(position === 'middle')
                this.middleImageLink = imageLink;
        },
        save: async function(fieldName, index = null ) {
            if(fieldName && fieldName.endsWith('Json')) {
                if(index == null) {
                    this.$parent.mediaProperty.configuration[fieldName] =
                        await translation.addTranslations(
                                this.$parent.mediaProperty.configuration[fieldName], 
                                translation.getTextForLanguage(this.$parent.mediaProperty.configuration[fieldName], 
                                                this.$parent.mediaProperty.defaultLanguage),
                                this.$parent.mediaProperty.languages, 
                                this.$parent.mediaProperty.defaultLanguage);
                }
                else {
                    this.$parent.mediaProperty.configuration.items[index].textJson =
                        await translation.addTranslations(
                        this.$parent.mediaProperty.configuration.items[index], 
                        translation.getTextForLanguage(this.$parent.mediaProperty.configuration.items[index].textJson, 
                                        this.$parent.mediaProperty.defaultLanguage),
                        this.$parent.mediaProperty.languages, 
                        this.$parent.mediaProperty.defaultLanguage);
                }
            }   

            const resp = this.processSaveResult(await data.saveMediaProperty(this.$parent.mediaProperty))
          
            if(!this.$parent.mediaProperty.id && resp.id) {
                this.$parent.mediaProperty.id = resp.id;
                this.$router.replace({path: this.$route.path, query: { ID: this.$parent.mediaProperty.id}});
            }
        },
        addLanguage: async function(lang) {
            await translation.addTranslationToField(this.$parent.mediaProperty.configuration.headerTextJson, lang, this.$parent.mediaProperty.defaultLanguage, true);
            await translation.addTranslationToField(this.$parent.mediaProperty.configuration.footerTextJson, lang, this.$parent.mediaProperty.defaultLanguage, true);
            for(var i = 0; i < this.$parent.mediaProperty.configuration.items.length; i++) {                
                await translation.addTranslationToField(this.$parent.mediaProperty.configuration.items[i].textJson, lang, this.$parent.mediaProperty.defaultLanguage, true);
            }            
        },
        deleteLanguage: async function(lang) {
            await translation.removeLanguageFromField(this.$parent.mediaProperty.configuration.headerTextJson, lang);
            await translation.removeLanguageFromField(this.$parent.mediaProperty.configuration.footerTextJson, lang);
            for(var i = 0; i < this.$parent.mediaProperty.configuration.items.length; i++) {                
                await translation.removeLanguageFromField(this.$parent.mediaProperty.configuration.items[i].textJson, lang);
            }   
        },
        addItem: function() {
            if(!this.$parent.mediaProperty.configuration.items) 
                this.$parent.mediaProperty.configuration.items = [];
            
            const newSequence = this.$parent.mediaProperty.configuration.items.length > 0 ? 
                this.$parent.mediaProperty.configuration.items[this.$parent.mediaProperty.configuration.items.length - 1].id + 1 : 1;
            this.$parent.mediaProperty.configuration.items.push({ id: newSequence});
        }
    }
}

</script>
<style scoped>
    textarea {
        width: 60%;
        height: 8.5em;
    }

    .formRow {
        display: flex;
        flex-direction: row;

        :deep(p) { display: none !important; }
        align-items: unset;
        input[type="text"] {
            width: 15rem;
            height: 1.5em;
            align-self: center;
        }

        h4 {
            width: 125px;
            margin: .75em 0;
        }

        :deep(button) {
            padding: 4px 8px !important;
        }
     
        div {
            align-self: center;
        }
    }

    .datagrid {
    display: flex;
    flex-direction: column;
}

.datagrid div.dataCell {
    display: flex;
    flex-direction: row;
    border: none;
    border-top: solid 1px;
    padding: 10px;
}

.tiny {
    flex: 0 0 20px;
    align-items: center;
}
.small { 
    flex: 0 0 60px;
}

.medium { 
    flex: 0 1 100px;
}
.large { 
    flex: 0 1 350px;
}

div.dataCell input {
    padding: 0px 5px;
}

.datagrid div.dataCell.last {
    border-bottom: solid 1px;
}

.datagrid div.dataCell.header {
    background-color: #a9a9a9;
    font-weight: bold;
    justify-content: left;
}

    div.dataCell .deleteButton {
        display: flex;
        position: relative;
        padding: 5px;
        bottom: unset;
        top: unset;
        right: unset;
    }

    div.dataCell div.colorSample {
        margin-left: 5px;
        height: 20px;
        width: 20px;
        align-self: center;
    }

    .gridRow {
        display: flex;
        flex-direction: row;
    }

    :deep(.tooltip-container) {
        align-self: center;
    }

</style>